// extracted by css-extract-rspack-plugin
export default {"wrapper":"_b513f9a0","divider":"_d076ad32","itemsWrapper":"_8a3d4ec6","tilesTitle":"_19a4ee14","tilesContainer":"_7cf41813","tile":"_d1c0c927","viewAllItemsButton":"_234dbacf"};